export const productReviewRatingLabels: Record<
    number,
    string
> = {
    1: "Very Poor",
    2: "Poor",
    3: "Average",
    4: "Good",
    5: "Excellent",
};

export const productReviewTips = [
    "Focus on product quality, fit, design, features and your experience using it.",
    "Photos or videos are optional, but they can help other customers understand the product better.",
    "Avoid including personal information, seller-service complaints or delivery details in the product review.",
];